export const getURLSearchParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params:{[key: string]: string} ={};
  for (const [key, value] of urlParams) {
    params[key] = value;
  }
  return params;
}
